<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#soa4r3nuha)">
            <path
                d="M10.5 5.25H6.75V1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.75H1.5c-.41 0-.75.34-.75.75s.34.75.75.75h3.75v3.75c0 .41.34.75.75.75s.75-.34.75-.75V6.75h3.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z"
            />
        </g>
        <defs>
            <clipPath id="soa4r3nuha">
                <path d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
